import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer } from '@ngrx/store';

export const editPresenceCredentialsFeatureKey = 'editPresenceCredentials';

export interface EditPresenceCredentialsState {
   callState: CallState;
}

export const initialState: EditPresenceCredentialsState = {
   callState: LoadingState.Init,
};

const editPresenceCredentialsReducer = createReducer(initialState);

export function reducer(state: EditPresenceCredentialsState | undefined, action: Action) {
   return editPresenceCredentialsReducer(state, action);
}
